module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_16.3ee77b12.jpg";